// src/components/ErrorBoundary.js
import React from "react";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Send logs to backend or logging service
        const payload = {
            error_type: "global",
            error_message: error.message,
            error_stack: error.stack,
            request_url: window.location.href,
            user_agent: navigator.userAgent,
            severity: error,
            source_app: "motorcycle"
        }
        fetch("/quote/utils/err", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: payload ? JSON.stringify(payload) : null,
        });
    }

    render() {
        if (this.state.hasError) {
            return <div style={{ background: "#fff", height: "100vh" }} />;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;